import { render, staticRenderFns } from "./paymentVerification.vue?vue&type=template&id=47ea150d&scoped=true"
import script from "./paymentVerification.vue?vue&type=script&lang=js"
export * from "./paymentVerification.vue?vue&type=script&lang=js"
import style0 from "./paymentVerification.vue?vue&type=style&index=0&id=47ea150d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ea150d",
  null
  
)

export default component.exports